import { UserOrderDetailsFilterType } from '@nw/shared/data-access';

import { TransformedUserOrdersData } from '../transformers/UserOrdersTransformer';

export class UserOrdersDetailsModel {
  private _userOrders: UserOrderDetailsFilterType[];

  constructor(data: TransformedUserOrdersData) {
    this._userOrders = data.userOrders;
  }

  /**
   * Get all user orders
   */
  get userOrders() {
    return this._userOrders;
  }

  /**
   * Get orders filtered by status
   */
  getOrdersByStatus(status: UserOrderDetailsFilterType['order_status']) {
    return this._userOrders.filter((order) => order.order_status === status);
  }

  /**
   * Get order by order ID
   */
  getOrderById(orderId: string): UserOrderDetailsFilterType | null {
    return this._userOrders.find((order) => order.order_id === orderId) || null;
  }

  /**
   * Get order by product code
   */
  getOrderByProductCode(
    productCode: string
  ): UserOrderDetailsFilterType | null {
    return (
      this._userOrders.find((order) => order.product_code === productCode) ||
      null
    );
  }

  /**
   * Get orders with installment payment details
   */
  getOrdersWithInstallments(): UserOrderDetailsFilterType[] {
    return this._userOrders.filter(
      (order) => order.installment_payment_details
    );
  }
}
